const AssetIcon = () => (
  <svg
    width='35'
    height='22'
    viewBox='0 0 35 22'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M14.4466 14H13.3137L16.5903 5.07654H17.7057L20.9823 14H19.8495L17.1829 6.48826H17.1132L14.4466 14ZM14.8649 10.5143H19.4312V11.4728H14.8649V10.5143Z'
      fill='black'
      fillOpacity='0.994819'
    />
    <path d='M1 1H34V21H1V1Z' stroke='black' strokeWidth='1.52294' />
  </svg>
)

export default AssetIcon
